"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    methods: {
        highlightOn: function highlightOn(proprietaire) {
            this.$set(proprietaire, "Highlight", true);
        },
        highlightOff: function highlightOff(proprietaire) {
            this.$set(proprietaire, "Highlight", false);
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./_wwwsrc/js/ConventionServitude/Mixins/HighlightProprietaire.ts
// module id = 237
// module chunks = 0